export default function SUCountdownShortcode() {
  /*! <fs_premium_only> */

  jQuery(function () {
    var formatterCache = {}

    function ready(callback) {
      if (document.readyState !== "loading") {
        callback()
        return
      }

      document.addEventListener("DOMContentLoaded", callback)
    }

    function getFormatter(timezone) {
      if (!timezone || !window.Intl || !window.Intl.DateTimeFormat) {
        return null
      }

      if (Object.prototype.hasOwnProperty.call(formatterCache, timezone)) {
        return formatterCache[timezone]
      }

      try {
        formatterCache[timezone] = new window.Intl.DateTimeFormat("en-US", {
          timeZone: timezone,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
          hourCycle: "h23",
        })
      } catch (error) {
        formatterCache[timezone] = null
      }

      return formatterCache[timezone]
    }

    function getDateParts(timestamp, timezone, offsetMinutes) {
      var formatter = getFormatter(timezone)
      var parts = {}
      var date
      var formattedParts

      if (formatter && formatter.formatToParts) {
        formattedParts = formatter.formatToParts(new Date(timestamp))

        formattedParts.forEach(function (part) {
          if (part.type !== "literal") {
            parts[part.type] = parseInt(part.value, 10)
          }
        })

        return {
          year: parts.year,
          month: parts.month,
          day: parts.day,
          hour: parts.hour === 24 ? 0 : parts.hour,
          minute: parts.minute,
          second: parts.second,
        }
      }

      date = new Date(timestamp + offsetMinutes * 60000)

      return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate(),
        hour: date.getUTCHours(),
        minute: date.getUTCMinutes(),
        second: date.getUTCSeconds(),
      }
    }

    function getPartsTimestamp(parts) {
      return Date.UTC(
        parts.year,
        parts.month - 1,
        parts.day,
        parts.hour,
        parts.minute,
        parts.second,
      )
    }

    function compareParts(left, right) {
      return getPartsTimestamp(left) - getPartsTimestamp(right)
    }

    function getDaysInMonth(year, month) {
      return new Date(Date.UTC(year, month, 0)).getUTCDate()
    }

    function hasVisibleUnit(visibleUnits, unit) {
      return Object.prototype.hasOwnProperty.call(visibleUnits, unit)
    }

    function addMonths(parts, months) {
      var monthIndex = parts.month - 1 + months
      var year = parts.year + Math.floor(monthIndex / 12)
      var month

      monthIndex %= 12

      if (monthIndex < 0) {
        monthIndex += 12
        year--
      }

      month = monthIndex + 1

      return {
        year: year,
        month: month,
        day: Math.min(parts.day, getDaysInMonth(year, month)),
        hour: parts.hour,
        minute: parts.minute,
        second: parts.second,
      }
    }

    function getRemainingParts(
      targetTimestamp,
      timezone,
      offsetMinutes,
      visibleUnits,
    ) {
      var nowTimestamp = Date.now()
      var nowParts
      var targetParts
      var totalMonths
      var candidateParts
      var consumedMonths = 0
      var remainingMonths
      var values = {
        years: 0,
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      }
      var remainder

      if (targetTimestamp <= nowTimestamp) {
        return null
      }

      nowParts = getDateParts(nowTimestamp, timezone, offsetMinutes)
      targetParts = getDateParts(targetTimestamp, timezone, offsetMinutes)
      totalMonths =
        (targetParts.year - nowParts.year) * 12 +
        targetParts.month -
        nowParts.month
      totalMonths = Math.max(0, totalMonths)
      candidateParts = addMonths(nowParts, totalMonths)

      if (compareParts(candidateParts, targetParts) > 0) {
        totalMonths = Math.max(0, totalMonths - 1)
        candidateParts = addMonths(nowParts, totalMonths)
      }

      remainingMonths = totalMonths

      if (hasVisibleUnit(visibleUnits, "years")) {
        values.years = Math.floor(remainingMonths / 12)
        consumedMonths += values.years * 12
        remainingMonths -= values.years * 12
      }

      if (hasVisibleUnit(visibleUnits, "months")) {
        values.months = remainingMonths
        consumedMonths += values.months
      }

      candidateParts = addMonths(nowParts, consumedMonths)
      remainder = Math.max(
        0,
        getPartsTimestamp(targetParts) - getPartsTimestamp(candidateParts),
      )

      if (hasVisibleUnit(visibleUnits, "days")) {
        values.days = Math.floor(remainder / 86400000)
        remainder -= values.days * 86400000
      }

      if (hasVisibleUnit(visibleUnits, "hours")) {
        values.hours = Math.floor(remainder / 3600000)
        remainder -= values.hours * 3600000
      }

      if (hasVisibleUnit(visibleUnits, "minutes")) {
        values.minutes = Math.floor(remainder / 60000)
        remainder -= values.minutes * 60000
      }

      if (hasVisibleUnit(visibleUnits, "seconds")) {
        values.seconds = Math.floor(remainder / 1000)
      }

      return values
    }

    function padUnit(unit, value) {
      if (unit === "hours" || unit === "minutes" || unit === "seconds") {
        return value < 10 ? "0" + value : String(value)
      }

      return String(value)
    }

    function animateDigit(digit) {
      digit.classList.remove("sue-countdown-digit-changing")
      window.setTimeout(function () {
        digit.classList.add("sue-countdown-digit-changing")
      }, 0)
      window.setTimeout(function () {
        digit.classList.remove("sue-countdown-digit-changing")
      }, 420)
    }

    function expireCountdown(state) {
      var message

      if (state.expired) {
        return
      }

      state.expired = true
      window.clearInterval(state.interval)
      state.element.classList.add("sue-countdown-expired")

      if (state.afterExpiration === "hide") {
        state.element.style.display = "none"
        state.element.setAttribute("aria-hidden", "true")

        return
      }

      if (!state.inner) {
        return
      }

      if (state.afterExpiration === "show_zeros") {
        Object.keys(state.digits).forEach(function (unit) {
          var digit = state.digits[unit]
          var value = padUnit(unit, 0)

          digit.textContent = value
          digit.setAttribute("data-value", value)
        })

        return
      }

      while (state.inner.firstChild) {
        state.inner.removeChild(state.inner.firstChild)
      }

      message = document.createElement("span")
      message.className = "sue-countdown-expired-text"
      message.textContent = state.expiredText
      state.inner.appendChild(message)
    }

    function updateCountdown(state, initial) {
      var remaining

      if (!document.documentElement.contains(state.element)) {
        window.clearInterval(state.interval)
        return
      }

      remaining = getRemainingParts(
        state.targetTimestamp,
        state.timezone,
        state.offsetMinutes,
        state.digits,
      )

      if (!remaining) {
        expireCountdown(state)
        return
      }

      Object.keys(state.digits).forEach(function (unit) {
        var digit = state.digits[unit]
        var value = padUnit(unit, remaining[unit])

        if (digit.getAttribute("data-value") === value) {
          return
        }

        digit.textContent = value
        digit.setAttribute("data-value", value)

        if (!initial && state.animation !== "disabled") {
          animateDigit(digit)
        }
      })
    }

    function initCountdown(element) {
      var units = element.querySelectorAll(".sue-countdown-unit")
      var targetTimestamp = parseInt(element.getAttribute("data-timestamp"), 10)
      var state = {
        element: element,
        inner: element.querySelector(".sue-countdown-inner"),
        targetTimestamp: isNaN(targetTimestamp) ? 0 : targetTimestamp * 1000,
        timezone: element.getAttribute("data-timezone") || "",
        offsetMinutes:
          parseInt(element.getAttribute("data-timezone-offset"), 10) || 0,
        expiredText: element.getAttribute("data-expired-text") || "",
        afterExpiration:
          element.getAttribute("data-after-expiration") || "show_empty_text",
        animation: "opacity",
        digits: {},
        interval: null,
        expired: false,
      }

      if (
        element.classList.contains("sue-countdown-digit-animation-disabled")
      ) {
        state.animation = "disabled"
      } else if (
        element.classList.contains("sue-countdown-digit-animation-flip")
      ) {
        state.animation = "flip"
      }

      Array.prototype.forEach.call(units, function (unit) {
        var key = unit.getAttribute("data-unit")
        var digit = unit.querySelector(".sue-countdown-digit")

        if (key && digit) {
          state.digits[key] = digit
        }
      })

      element.classList.add("sue-countdown-ready")
      updateCountdown(state, true)

      if (!state.expired) {
        state.interval = window.setInterval(function () {
          updateCountdown(state, false)
        }, 1000)
      }
    }

    function initCountdowns() {
      var countdowns = document.querySelectorAll(
        ".sue-countdown:not(.sue-countdown-ready)",
      )

      Array.prototype.forEach.call(countdowns, initCountdown)
    }

    function observeCountdowns() {
      var observer

      if (!window.MutationObserver || !document.body) {
        return
      }

      observer = new window.MutationObserver(function (mutations) {
        var shouldInit = false

        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType !== 1) {
              return
            }

            if (
              node.classList.contains("sue-countdown") ||
              node.querySelector(".sue-countdown")
            ) {
              shouldInit = true
            }
          })
        })

        if (shouldInit) {
          initCountdowns()
        }
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })
    }

    ready(function () {
      initCountdowns()
      observeCountdowns()
    })
  })

  /*! </fs_premium_only> */
}
